












































import { Component, Vue } from "vue-property-decorator";
import { Icon, Button, Field } from "vant";
import { verifyTradePassword } from "@/utils/verify";

@Component({
  name: "TradePasswordSetting",
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Field.name]: Field
  }
})
export default class TradePasswordSetting extends Vue {
  form = {
    password: "",
    repeat_password: ""
  };

  get isDisabledSubmit() {
    return Object.keys(this.form).some(key => {
      return !this.form[key];
    });
  }

  handleSubmit() {
    if (!verifyTradePassword(this.form.password)) {
      return this.$toast(this.$t("common.trade_password_verify_fail_text"));
    }
    if (this.form.repeat_password !== this.form.password) {
      return this.$toast(this.$t("common.trade_password_repeat_fail_text"));
    }
    (this as any).$apis
      .saveTradePassword(this.form)
      .then(() => {
        this.$router.push("/electronic-sign");
      })
      .catch(e => {
        
      });
  }
}
